var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"lottie-bg",attrs:{"element-loading-text":"拼命加载中"}},[_c('div',{attrs:{"id":"lottie"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }